import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="search"
export default class extends Controller {
    static values = {minChars: {type: Number, default: 3}, delay: {type: Number, default: 250}}

    submit(e) {
        clearTimeout(this.timeout)
        const query = e.target.value.trim()
        if (query.length > 0 && query.length < this.minCharsValue) return

        this.timeout = setTimeout(() => {
            this.element.requestSubmit()
        }, this.delayValue)
    }
}
